import { Component, Input, OnInit } from '@angular/core';
import { Step } from 'projects/mydocma/import-export/src/lib/stepper/step/step';
import { StepComponent, StepData } from 'projects/mydocma/import-export/src/lib/stepper/step/step.component';
import { StepperService } from 'projects/mydocma/import-export/src/lib/stepper/stepper.service';
import { from } from 'rxjs';
import { NavigationService } from '../navigation.service';
import { Step2Service } from './step2.service';

@Component({
  selector: 'app-stepper-navigation-step2',
  templateUrl: './step2.component.html',
  styleUrls: ['./step2.component.scss'],
  providers: [
    Step2Service
  ]
})
export class Step2Component implements OnInit, StepComponent {

  @Input()
  step: Step;
  
  options = []; 
  selectedType = null;


  constructor(private readonly stepperService: StepperService,
              private readonly navigationService: NavigationService,
              private readonly step2Service: Step2Service
              ) { }
  
  ngOnInit() {
  }

  enter() {
    // this.stepperService.setStepData(this.step, { valid: true, error: '', data: {} });
    const prev = this.stepperService.getStepByIndex(0);

    //this.options = ['A1', 'A22']

    this.navigationService.loading = true;
    from(this.step2Service.load(prev.data)).subscribe(o=> {
      this.options = o
      this.navigationService.loading = false;
    }
      
    );


  }

  async validate(): Promise<StepData> {
    if (!this.selectedType) {
      return {valid: false}
     } else {
      this.navigationService.loading = true;
      const stepData = {
              valid: true,
              data: this.selectedType
            };

      //  const stepData = await timer(0).pipe(
      //    map(()=>{
      //     return {
      //      valid: true,
      //      data: this.selectedType
      //    }
      //  })).toPromise();

       this.navigationService.loading = false;

       return stepData;
    }
  }

  async next() {
    await this.stepperService.nextStep();
  }

  reset() {
    this.selectedType = null;
  }
}
